<template>
  <div class="h-full w-full layout-column gap-sm justify-center">
    <div class="typography-display-large self-center">
      404
    </div>
    <h4 class="typography-body-1-regular self-center">
      {{ $t('notFound.title') }}
    </h4>
    <p class="typography-body-1-regular self-center">
      {{ $t('notFound.text') }}
    </p>
    <div class="layout-column self-center">
      <OrButtonV3 @click="router.back()">
        {{ $t('notFound.goBack') }}
      </OrButtonV3>
    </div>
  </div>
</template>

<script setup lang="ts">
import { OrButtonV3 } from '@onereach/ui-components';
import { useRouter } from 'vue-router';

const router = useRouter();
</script>
